module.exports = __webpack_public_path__ + "img/tree-05-c-leaves.3b435830.png";